import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { Plan } from 'modules/main/auth/register/models/plans';

export interface ChoosePlanResponse {
	payment_id: string;
	payment_url: string;
	plan: { id: number; name: string | null; price: string };
	reference: string;
}

export const onGetPlans = async () => {
	try {
		const response = await axios.get<JsonResponse<{ plans: Plan[] }>>(`register/get-plans`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onChoosePlan = async (plan_id: number) => {
	try {
		const response = await axios.post<JsonResponse<ChoosePlanResponse>>(`dashboard/upgrade-plan/${plan_id}/payment-url`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
